import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Modal } from 'ui-components/components/modal';
import { Button } from 'ui-components/components/button';
import { testId } from 'ui-components/services/testid-service';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { withGuard } from 'ui-components/components/with-guard';

import ModalPortal from '../../../../../components/modal-portal';

import { messages } from './messages';
import style from './invite-errors-modal.module.less';

export const RowsDataContext = React.createContext();

const InviteErrorsModal = ({ onClose, inviteErrors }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal {...testId('invite-error-vendor-modal')} size='small'>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage {...messages.modalHeader} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <div className={style['modal-body-text']}>
            <FormattedMessage {...messages.InviteErrorsModalBodyText} />
          </div>
          <ul className={style['failed-vendor-invites-list']}>
            {inviteErrors.map((invite) => (
              <li key={invite.recipientEmail} className={style['failed-vendor-bullet']}>
                {' '}
                {invite.recipientEmail}{' '}
              </li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} theme='primary'>
            <FormattedMessage {...messages.closeButton} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

InviteErrorsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  inviteErrors: PropTypes.arrayOf(
    PropTypes.shape({
      recipientEmail: PropTypes.string.isRequired,
      errors: PropTypes.arrayOf(
        PropTypes.shape({
          message: PropTypes.string,
          code: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
};

const ExtendedModal = withGuard(InviteErrorsModal);
export { ExtendedModal as InviteErrorsModal };
